import { termsFieldName } from "./termsCurrency";

/**
 * The terms-currency halves of the contract-derived financial rollups on deals
 * are deliberately neither sortable nor filterable: each deal's value is in its
 * own contract's currency, so values across deals do not compare. Sorting is
 * suppressed by `enableSorting: false` on the column defs, and since the fields
 * model carries no `filterable` flag the filter picker has to be gated in the
 * frontend instead. The account-currency halves sort and filter like any amount.
 *
 * These keys live in their own module because two layers need them and must not
 * disagree: the filter picker, which stops offering them, and the view
 * deserializer, which drops one already persisted in a saved view. A field
 * withheld from the picker but retained in a saved view keeps filtering with no
 * chip to remove it.
 *
 * Not derived from `DealColumn`: that enum's `CONTRACTS_TCV` / `CONTRACTS_ACV`
 * members hold the deal-native `totalContractValue` / `annualContractValue`
 * keys, which must stay filterable — deriving from it would withhold exactly
 * the fields this gate is required to leave alone.
 */
const CONTRACT_ROLLUP_METRIC_KEYS = [
  "contractsCarr",
  "contractsCmrr",
  "contractsTcv",
  "contractsAcv",
  "contractsTotalContractValue",
  "contractsAnnualContractValue"
] as const;

// Two migrations spell the same registry rows differently (TCV/ACV written out
// in full vs. abbreviated), so the terms half of every spelling is listed. Keys
// compare camelCased, which is what the entity-fields endpoint emits and what a
// snake_case row normalizes to.
export const NON_FILTERABLE_CONTRACT_ROLLUP_FIELD_KEYS = new Set<string>(
  CONTRACT_ROLLUP_METRIC_KEYS.map(termsFieldName)
);
